import { ISignInError } from '../../store/signIn/types';

export enum ESignInProvider {
    MICROSOFT = 'MICROSOFT',
    GOOGLE = 'GOOGLE',
}

export interface ISignInButtonsFields {
    buttonSignInGoogle?: string;
    buttonSignInMicrosoft?: string;
    error: ISignInError;
    isShowGoogle?: boolean;
    isShowMicrosoft: boolean;
}

export interface ISignInButtonsEvents {
    onClickContact: () => void;
    onClickDemo: () => void;
    onClickFaq: () => void;
    onClickReload: () => void;
    onClickSignIn: (provider: ESignInProvider) => void;
    onClickTryAgain: (provider: ESignInProvider) => void;
}

export interface ISignInButtonsProps extends
    ISignInButtonsFields,
    ISignInButtonsEvents
{}
